import gql from "graphql-tag";

export const GET_SOURCECOUNTS = gql`
	query sourceCounts($status: DocumentStatus!) {
		sourceCounts(status: $status) {
			id, source, count
		}
	}
`;
